export default __webpack_public_path__ + "static/media/dono.857b7557.png";